import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';

import { ClienteFechamentoService } from '@core/services/cliente-fechamento.service';

@Component({
	selector: 'app-view-cliente-fechamento',
	templateUrl: './view-cliente-fechamento.component.html',
	styleUrls: ['./view-cliente-fechamento.component.scss']
})
export class ViewClienteFechamentoComponent implements OnInit {
	public apiData;
	public urlLastValue;
	public url = this.router.url;
	public sidebarToggleRef = false;
	public paymentSidebarToggle = false;
	private _unsubscribeAll: Subject<any>;
	public faturaEncontrada: boolean = false;
	public pageLoading: boolean = false;

	constructor(
		private router: Router,
		private clienteFechamentoService: ClienteFechamentoService
	) {
		this._unsubscribeAll = new Subject();
		this.urlLastValue = this.url.substr(this.url.lastIndexOf('/') + 1);
	}

	ngOnInit(): void {
		this.pageLoading = true;
		this.clienteFechamentoService.findOne(this.urlLastValue).subscribe(
			(res) => {
				if (res.length > 0) {
					this.apiData = res[0];
					this.faturaEncontrada = true;
					this.pageLoading = false;
				} else {
					this.faturaEncontrada = false;
					this.pageLoading = false;
				}
			},
			(err) => {
				console.log(err);

			}
		);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
